<div class="form-group">
    <input type="text" classs="form-control" placeholder="SearchVillages" [(ngModel)]="searchTerm" />
</div>

<div class="row">
    <div class="col">
        <app-add-new-village [filteredVillages]="filteredVillages" [provincesOptions]="provincesOptions" [provincesList]="provincesList"></app-add-new-village>
    </div>
</div>
<div class="row">
    <div class="col">
        <div class="table-responsive">
            <table class="table table-striped table-sm">
                <thead>
                    <tr>
                        <th scope="col">Id</th>
                        <th scope="col">Name</th>
                        <th scope="col">Province</th>
                        <th scope="col"></th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let village of filteredVillages; let i = index">
                        <tr scope="row" [ngClass]="{'bluBottomLine': i === filteredVillages.length - 1}">
                            <ng-container *ngIf="choosenEditVillage.id === village.id; else displayTemplate">
                                <td colspan="4">
                                    <app-edit-village-form [village]="choosenEditVillage" [provincesList]="provincesList" [villagesList]="villagesList" [provincesOptions]="provincesOptions" (getCancelEditModeEvent)="cancelVillageEditMode()" (geResetVillagesList)="resetVillageList($event)">
                                    </app-edit-village-form>
                                </td>
                            </ng-container>
                            <ng-template #displayTemplate>
                                <td>
                                    {{village.id}}
                                </td>
                                <td>
                                    {{village.name}}
                                </td>
                                <td>
                                    {{village.province.name}}
                                </td>
                                <td class="text-right">
                                    <div class="btn-group btn-group-sm" role="group" aria-label="Button group with nested dropdown">
                                        <button type="button" class="btn btn-link" title="Edit" (click)="enableEditVillage(village)"><i class="fa fa-edit"></i></button>
                                        <!--
                                        <button type="button" class="btn btn-link" placement="top" [ngbTooltip]="Delete" (click)="showConfirmDeleteDialog(village.id)"><i class="fa fa-trash"></i></button>
                                        -->
                                    </div>
                                </td>
                            </ng-template>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>
    </div>
</div>
<app-confirm-dialog-model #confirmDeleteVillageDialog (getResult)="getDeleteVillageDecision($event)" modalTitle="Village Elimination" modalContent="Do you want to delete this village?" denyText="NO" acceptText="YES">
</app-confirm-dialog-model>
